/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type OrdersAttachmentsDestroyRequest = {} | null | undefined;
export type OrdersAttachmentsDestroyResponse = any;

export type OrdersAttachmentsDestroyQuery = {
  /**
   * ```yaml
   * in: path
   * name: attachment_id
   * schema:
   *   type: string
   *   pattern: ^\d+$
   * required: true
   * ```
   */
  attachment_id?: string;

  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * DELETE /dmx-server/orders/{id}/attachments/{attachment_id}/
 *
 * ```yaml
 * operationId: orders_attachments_destroy
 * tags:
 *   - orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 *   '404':
 *     description: Unknown attachment
 * ```
 */
export const ordersAttachmentsDestroyOperation = ({
  id,
  attachment_id,
  ...rest
}: OrdersAttachmentsDestroyQuery) =>
  ({
    method: 'DELETE',
    path: `/dmx-server/orders/${id}/attachments/${attachment_id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'DELETE';
    path: string & { _templateUrl: '/dmx-server/orders/{id}/attachments/{attachment_id}/' };
  };

/**
 * DELETE /dmx-server/orders/{id}/attachments/{attachment_id}/
 *
 * ```yaml
 * operationId: orders_attachments_destroy
 * tags:
 *   - orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 *   '404':
 *     description: Unknown attachment
 * ```
 */
export const ordersAttachmentsDestroy = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: OrdersAttachmentsDestroyQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = ordersAttachmentsDestroyOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'DELETE',
    request,
    onUploadProgress,
    cancelToken,
  );
};
